/* ============================================================
   JUÉ — site behavior (Shopify edition)
   ============================================================ */

(function () {
  'use strict';

  // Shopify cart endpoints
  const ENDPOINTS = {
    add: '/cart/add.js',
    cart: '/cart.js',
    update: '/cart/update.js',
    change: '/cart/change.js',
  };

  let cart = { items: [], total_price: 0, item_count: 0 };

  // -------- Cart API --------
  async function fetchCart() {
    try {
      const r = await fetch(ENDPOINTS.cart);
      cart = await r.json();
      renderCart();
    } catch (e) { console.error('fetchCart', e); }
  }

  async function addItem(variantId, quantity = 1) {
    try {
      const r = await fetch(ENDPOINTS.add, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity })
      });
      if (!r.ok) throw new Error('add failed');
      await fetchCart();
      openCart();
      return true;
    } catch (e) {
      console.error('addItem', e);
      return false;
    }
  }

  async function removeItem(key) {
    try {
      await fetch(ENDPOINTS.change, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      });
      await fetchCart();
    } catch (e) { console.error('removeItem', e); }
  }

  // -------- Format --------
  function fmtPrice(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  // -------- Render cart drawer --------
  function renderCart() {
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = cart.item_count ? `(${cart.item_count})` : '';
    });

    const itemsEl = document.querySelector('[data-cart-items]');
    const footEl = document.querySelector('[data-cart-foot]');
    if (!itemsEl) return;

    if (!cart.items || cart.items.length === 0) {
      itemsEl.innerHTML = `
        <div class="cart-empty">
          <div class="display">Your bag is empty.</div>
          <p>The collection is waiting. Find your color.</p>
          <a href="/collections/plein-soleil-ss26" class="cta cta--light">Find your color</a>
        </div>`;
      if (footEl) footEl.style.display = 'none';
      return;
    }

    itemsEl.innerHTML = cart.items.map(item => {
      const img = item.image ? `<img src="${item.image}" alt="${item.product_title}">` : '<div style="width:80px;aspect-ratio:3/4;background:rgba(0,0,0,0.04);"></div>';
      const colorDesc = item.options_with_values && item.options_with_values.length > 0
        ? item.options_with_values.map(o => o.value).filter(v => v !== 'Default Title').join(' · ')
        : '';
      return `
        <div class="cart-item">
          ${img}
          <div class="ci-info">
            <div class="ci-name">${item.product_title}</div>
            ${colorDesc ? `<div class="ci-color">${colorDesc}</div>` : ''}
            <div class="ci-price">${fmtPrice(item.final_line_price)}${item.quantity > 1 ? ' · ' + item.quantity : ''}</div>
          </div>
          <button class="ci-remove" data-remove="${item.key}" aria-label="Remove">Remove</button>
        </div>`;
    }).join('');

    if (footEl) {
      footEl.style.display = 'block';
      const totalEl = footEl.querySelector('.cart-total .amount');
      if (totalEl) totalEl.textContent = fmtPrice(cart.total_price);
    }

    itemsEl.querySelectorAll('[data-remove]').forEach(btn => {
      btn.addEventListener('click', () => removeItem(btn.dataset.remove));
    });
  }

  // -------- Cart drawer open/close --------
  function openCart() {
    document.querySelector('[data-cart-drawer]')?.classList.add('is-open');
    document.querySelector('[data-cart-backdrop]')?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    document.querySelector('[data-cart-drawer]')?.classList.remove('is-open');
    document.querySelector('[data-cart-backdrop]')?.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  // -------- Mobile nav --------
  function initMobileNav() {
    const burger = document.querySelector('[data-burger]');
    const menu = document.querySelector('[data-mobile-menu]');
    if (!burger || !menu) return;

    burger.addEventListener('click', () => {
      const isOpen = menu.classList.toggle('is-open');
      burger.classList.toggle('is-open', isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });

    menu.querySelectorAll('a').forEach(a => {
      a.addEventListener('click', () => {
        menu.classList.remove('is-open');
        burger.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    });
  }

  // -------- Nav scroll state --------
  function initNavScroll() {
    const nav = document.querySelector('.nav');
    if (!nav) return;
    const onScroll = () => {
      const y = window.scrollY;
      const trigger = nav.dataset.solidAfter ? parseInt(nav.dataset.solidAfter) : 80;
      nav.classList.toggle('solid', y > trigger);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // -------- Reveals --------
  function initReveals() {
    const els = document.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window)) {
      els.forEach(el => el.classList.add('is-in'));
      return;
    }
    const winH = window.innerHeight;
    els.forEach(el => {
      const r = el.getBoundingClientRect();
      if (r.top < winH * 0.9) el.classList.add('is-in');
    });
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    els.forEach(el => { if (!el.classList.contains('is-in')) io.observe(el); });
  }

  // -------- Add to cart bindings --------
  function initAddButtons() {
    document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
      btn.addEventListener('click', async () => {
        const variantId = btn.dataset.addToCart;
        if (!variantId || variantId === '0') {
          alert('This piece is not available.');
          return;
        }
        const orig = btn.innerHTML;
        btn.disabled = true;
        btn.innerHTML = 'Adding…';
        const ok = await addItem(variantId, 1);
        if (ok) {
          btn.innerHTML = 'Added ✓';
        } else {
          btn.innerHTML = 'Sold out';
        }
        setTimeout(() => { btn.innerHTML = orig; btn.disabled = false; }, 1600);
      });
    });
  }

  // -------- Cart triggers --------
  function initCartTriggers() {
    document.querySelectorAll('[data-open-cart]').forEach(b => {
      b.addEventListener('click', (e) => { e.preventDefault(); openCart(); });
    });
    document.querySelectorAll('[data-close-cart]').forEach(b => {
      b.addEventListener('click', closeCart);
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeCart();
    });
  }

  // -------- Newsletter — Shopify's built-in customer signup form handles itself --------
  // We just visually confirm on submit
  function initNewsletter() {
    document.querySelectorAll('[data-newsletter]').forEach(form => {
      form.addEventListener('submit', (e) => {
        // Let Shopify handle the real submission, but show our confirmation
        const note = form.parentElement.querySelector('.form-note');
        if (note) {
          setTimeout(() => {
            note.textContent = "You're in. The next chapter begins in your inbox.";
            note.style.opacity = '1';
          }, 100);
        }
      });
    });
  }

  // -------- Init --------
  function init() {
    initMobileNav();
    initNavScroll();
    initReveals();
    initAddButtons();
    initCartTriggers();
    initNewsletter();
    fetchCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
